import React from 'react';
import { formatVoicePlaybackSpeed, VOICE_ACTIVE_COLOR } from './FooterVoice.constants';

const VoicePlaybackSpeedButton = ({
    playbackSpeed,
    onClick,
    isDarkMode,
    isOnPrimaryBubble = false,
    color,
}) => {
    const speedLabel = formatVoicePlaybackSpeed(playbackSpeed);

    return (
        <button
            type="button"
            aria-label={`Playback speed ${speedLabel}`}
            title={`Playback speed ${speedLabel}`}
            onClick={onClick}
            style={{
                width: 28,
                height: 24,
                minWidth: 28,
                padding: 0,
                border: 'none',
                borderRadius: 12,
                background: 'transparent',
                color: color || (isOnPrimaryBubble
                    ? 'rgba(255, 255, 255, 0.88)'
                    : isDarkMode ? '#7dd3fc' : VOICE_ACTIVE_COLOR),
                cursor: 'pointer',
                fontSize: 11,
                fontWeight: 700,
                lineHeight: '24px',
                textAlign: 'center',
                flexShrink: 0,
            }}
        >
            {speedLabel}
        </button>
    );
};

export default VoicePlaybackSpeedButton;
